import {
  UserFollowedDataSubjectFormDataType,
  UserFollowedDataSubjectMutationDtoType,
  UserFollowedDataSubjectValidFormDataType,
} from './types';
import { UserFollowedDataSubjectMutationDtoSchema } from './UserFollowedDataSubjectMutationDtoSchema';
import { UserFollowedDataSubjectValidFormDataSchema } from './UserFollowedDataSubjectValidFormDataSchema';
import { UserFollowedDataSubjectFormDataSchema } from './UserFollowedDataSubjectFormDataSchema';

export class UserFollowedDataSubjectSchema {
  static parseFormData<Dto>(data: Dto): UserFollowedDataSubjectFormDataType {
    return UserFollowedDataSubjectFormDataSchema.parse(data);
  }

  static parseMutationDto<
    ValidFormData extends Partial<UserFollowedDataSubjectValidFormDataType>,
  >(validFormData: ValidFormData): UserFollowedDataSubjectMutationDtoType {
    return UserFollowedDataSubjectMutationDtoSchema.parse(validFormData);
  }

  static validFormDataSchema = UserFollowedDataSubjectValidFormDataSchema;
}
